import {
  logError as defaultLogError,
  logWarn as defaultLogWarn,
  logDebug as defaultLogDebug,
  logInfo as defaultLogInfo,
  log as defaultLog,
} from './logger';

const clientName = 'UMP';
export const logError = defaultLogError.bind({}, clientName);
export const logWarn = defaultLogWarn.bind({}, clientName);
export const logDebug = defaultLogDebug.bind({}, clientName);
export const logInfo = defaultLogInfo.bind({}, clientName);
export const log = defaultLog.bind({}, clientName);